import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      &copy; 2025 DKC Exports. All rights reserved
    </footer>
  );
};

export default Footer;
